import { ChangeDetectionStrategy, Component } from '@angular/core'
import { OfferSelectionCardModel } from '@flocasts/experience-service-types'
import { combineLatest, map } from 'rxjs'
import {
  FEAT_VERTICAL_OFFERS_ID,
  FEAT_VERTICAL_OFFERS_VARIATION
} from 'src/app/shared/experimentation/experiment.model'
import { ExperimentationService } from 'src/app/shared/experimentation/experimentation.service'
import { trackById } from 'src/app/shared/utility-functions/track-by-id.utility'
import { OffersService } from 'src/app/singleton-services/offers.service'
import { OfferStyle } from './offer-selection/offer-selection-card.interface'

@Component({
  selector: 'flo-offers',
  templateUrl: './offers.component.html',
  styleUrls: ['./offers.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class OffersComponent {
  constructor(
    private readonly offersService: OffersService,
    private readonly experimentService: ExperimentationService
  ) {}

  public isInVerticalOfferVariation$ = this.experimentService.isInVariation(
    FEAT_VERTICAL_OFFERS_ID,
    FEAT_VERTICAL_OFFERS_VARIATION,
    true
  )

  public config$ = combineLatest([
    this.offersService.offers$,
    this.offersService.selectedOffer$,
    this.isInVerticalOfferVariation$
  ]).pipe(
    map(([offers, selectedOffer, isInVerticalOfferVariation]) => {
      return {
        offers,
        selectedOffer,
        isInVerticalOfferVariation,
        style: isInVerticalOfferVariation ? OfferStyle.VERTICAL : OfferStyle.DEFAULT
      }
    })
  )

  public updateSelectedOffer(offer: OfferSelectionCardModel) {
    this.offersService.updateSelectedOffer(offer)
  }

  trackById = trackById
}
